export default __webpack_public_path__ + "static/media/Inventory-green-box-icon.5d1d89e7.svg";